// Journey 2 — data to decision: information is ingested, its lineage proves it,
// the LOE board rolls it up, and the command center turns it into a call.
import { ANCHORS } from '../../features/tours/tourAnchors.js';

export const j2DataToDecision = {
  id: 'j2-data-to-decision',
  title: 'From data to decision',
  // 5 minutes matches the welcome journey card (welcomeContent.journeyCards)
  // and the SME Welcome Kit copy — keep the SME-facing estimate consistent.
  minutes: 5,
  steps: [
    {
      id: 'j2-ingestion',
      route: '/admin/ingestion',
      routeKey: '/admin/ingestion',
      anchor: ANCHORS.ingestionUpload,
      title: 'Data comes in here',
      body: 'Information enters through ingestion. This upload zone takes a file, checks it, and walks it through mapping and validation before anything is committed.',
      fallbackBody: 'The ingestion center is where data stewards bring outside information in and validate it.',
    },
    {
      id: 'j2-lineage',
      route: '/admin/lineage',
      routeKey: '/admin/lineage',
      anchor: ANCHORS.lineageGraph,
      title: 'Prove where it came from',
      body: 'Lineage shows where every number came from. Follow a record back through each source it passed through to judge how far it can be trusted.',
      fallbackBody: 'The lineage explorer traces each number back through every source that produced it.',
    },
    {
      id: 'j2-loe-board',
      route: '/loe-dashboard',
      routeKey: '/loe-dashboard',
      anchor: ANCHORS.loeBoard,
      title: 'Rolled up by priority',
      body: 'The LOE board rolls those trusted numbers up by line of effort, so the Director sees each priority area at a glance.',
    },
    {
      id: 'j2-command-center',
      route: '/executive',
      routeKey: '/executive',
      anchor: ANCHORS.execCommandCenter,
      title: 'Turned into a decision',
      body: 'The command center is where it all lands as a decision. The daily brief summarizes what changed and what needs the Director’s attention today.',
      fallbackBody: 'The executive command center and its daily brief turn the rolled-up picture into decisions.',
    },
  ],
  closingNarrative:
    'That is data to decision end to end: ingestion brings information in, lineage proves it, the LOE board rolls it up, and the command center turns it into a call. Three systems, one trusted thread.',
};
